import React from 'react'

function AddressFormSelect({
  containerDivClasses,
  containerDivId,
  labelText,
  optionsArray,
  selectName,
  selectId,
  selectValue,
  onChange,
  disabled,
  errors = [],
}) {
  let selectClasses = "form-group " + containerDivClasses;
  if (errors.length >= 1) {
    selectClasses += " error";
  }

  return (
    <div className={selectClasses} id={containerDivId}>
      <label className="select-label" htmlFor={selectId}>{labelText}</label>
      <span className="select-wrap">
        <select 
          className="form-control" 
          name={selectName} 
          id={selectId} 
          value={selectValue} 
          onChange={onChange}
          disabled={disabled}
        >
        {
          optionsArray.map((option, index) => {
            return <option key={index} value={option.value}>{option.label}</option>
          })
        }
        </select>
      </span>
      {errors.length >= 1 && 
        <ul>
          {errors.map((error, index) => (
            <li key={index}>{error}</li>
          ))}
        </ul>
      }
    </div>
  )
}

export default AddressFormSelect;